import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, CloseButton } from 'react-bootstrap';


const ConfirmModal = ({ show, title, message, onClose, onConfirm, size = 'md', data }) => {
    const [showModal, setShow] = useState(show);

    React.useEffect(() => {
        setShow(show);
    }, [show])

    const onModalClose = () => {
        onClose();
    }

    const onClickConfirm = () => {
        onConfirm(data);
    }

    return (
        <Modal
            show={showModal}
            size={size}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header>
                <Modal.Title>
                    {title}
                </Modal.Title>
                <button className='btn btn-close close' onClick={onModalClose}>
                    <i className='fa fa-close' />
                </button>
            </Modal.Header>
            <Modal.Body>
                <p>
                    {message}
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant='danger' data-dismiss='modal' onClick={onModalClose}>No</Button>
                <Button variant='primary' onClick={onClickConfirm}>Yes</Button>
            </Modal.Footer>
        </Modal>
    );
}

ConfirmModal.propTypes = {
    show: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    data: PropTypes.any,
    size: PropTypes.string,
}

export default ConfirmModal;
